import SqFetch from 'typescript/application/sq_fetch';

/**
 * this file is used to mock SqFetch methods for testing
 * mocked methods: post, get, put, delete
 */

const mockSqFetchPost = jest.spyOn(SqFetch, 'post');
const mockSqFetchGet = jest.spyOn(SqFetch, 'get');
const mockSqFetchPut = jest.spyOn(SqFetch, 'put');
const mockSqFetchDelete = jest.spyOn(SqFetch, 'delete');

const mockSqFetchPostSuccess = (
  resolvedJson?: Record<any, any> | string,
): void => {
  mockSqFetchPost.mockResolvedValueOnce({
    ok: true,
    json: () => Promise.resolve(resolvedJson || {}),
  } as Response);
};

const mockSqFetchPostFailure = (
  status: number,
  statusText?: string,
  resolvedJson?: Record<string, unknown>,
): void => {
  mockSqFetchPost.mockResolvedValueOnce({
    ok: false,
    status,
    statusText: statusText || 'Bad Request',
    json: () => Promise.resolve(resolvedJson || { error: 'Bad Request' }),
  } as Response);
};

const mockSqFetchGetSuccess = (
  resolvedJson?: Record<string, unknown>,
): void => {
  mockSqFetchGet.mockResolvedValueOnce({
    ok: true,
    json: () => Promise.resolve(resolvedJson || {}),
  } as Response);
};

const mockSqFetchGetFailure = (
  status: number,
  statusText?: string,
  resolvedJson?: Record<string, unknown>,
): void => {
  mockSqFetchGet.mockResolvedValueOnce({
    ok: false,
    status,
    statusText: statusText || 'Bad Request',
    json: () => Promise.resolve(resolvedJson || { error: 'Bad Request' }),
  } as Response);
};

const mockSqFetchDeleteSuccess = (resolvedJson?: Record<any, any>): void => {
  mockSqFetchDelete.mockResolvedValueOnce({
    ok: true,
    json: () => Promise.resolve(resolvedJson || {}),
  } as Response);
};

const mockSqFetchDeleteFailure = (
  status: number,
  statusText?: string,
  resolvedJson?: Record<string, unknown>,
): void => {
  mockSqFetchDelete.mockResolvedValueOnce({
    ok: false,
    status,
    statusText: statusText || 'Bad Request',
    json: () => Promise.resolve(resolvedJson || { error: 'Bad Request' }),
  } as Response);
};

const mockSqFetchPutSuccess = (
  resolvedJson?: Record<any, any> | string,
): void => {
  mockSqFetchPut.mockResolvedValueOnce({
    ok: true,
    json: () => Promise.resolve(resolvedJson || {}),
  } as Response);
};

const mockSqFetchPutFailure = (
  status: number,
  statusText?: string,
  resolvedJson?: Record<string, unknown>,
): void => {
  mockSqFetchPut.mockResolvedValueOnce({
    ok: false,
    status,
    statusText: statusText || 'Bad Request',
    json: () => Promise.resolve(resolvedJson || { error: 'Bad Request' }),
  } as Response);
};

export {
  mockSqFetchPost,
  mockSqFetchGet,
  mockSqFetchPut,
  mockSqFetchDelete,
  mockSqFetchPostSuccess,
  mockSqFetchPostFailure,
  mockSqFetchGetSuccess,
  mockSqFetchGetFailure,
  mockSqFetchPutSuccess,
  mockSqFetchPutFailure,
  mockSqFetchDeleteSuccess,
  mockSqFetchDeleteFailure,
};
